<template>
	<div>

	<el-container>
	  <el-header style = "padding:0;height: auto;">
		  <el-row>
		    <el-col :span="24">
				<header-top></header-top>
			</el-col>
			<el-col :span="24">
				<header-body></header-body>
			</el-col>
			<el-col :span="24">
				<header-footer :page = "'index'"></header-footer>
			</el-col>
		  </el-row>
	  </el-header>
	  
	  
	  <el-main>
		  
		 <banner></banner>
		 <display-data></display-data> 
		 
		 
		<index-order :id = "item.value" v-for="(item,index) in systemData.topOrderType" :key = "index" :imgSort="index" :orderType = "item"></index-order>
		 
		
		 
	  </el-main>
	   <yumi-footer></yumi-footer>
	</el-container>


	</div>
</template>


<script>

	import headerTop from '../../components/header/headerTop.vue'
	import headerBody from '../../components/header/header-body.vue'
	import headerFooter from '../../components/header/header-footer.vue'
	import banner from '../../components/banner/banner.vue'
	import displayData from '../../components/displayData/displayData.vue'
	import orderBox from '../../components/orderBox/orderBox.vue'
	import orderBanner  from '../../components/orderBanner/orderBanner.vue'
	import yumiFooter from '../../components/yumiFooter/yumiFooter.vue'
	import indexOrder from '../../components/indexOrder/indexOrder.vue'
	import {getSystemData} from '../../api/cus.js'
	import {getInfo} from '../../api/login.js'
	import {getToken} from '../../utils/auth.js'
	import {mapGetters} from 'vuex'
	export default{
		components:{
			headerTop,
			headerBody,
			headerFooter,
			banner,
			displayData,
			orderBox,
			orderBanner,
			yumiFooter,
			indexOrder,
			
		},
		computed:{
	...mapGetters(['systemData'])
},
		data(){
			return {}
		},
		created() {
			getSystemData().then(res=>{
				
				this.$store.dispatch("initSystemData",res)
			
			})
			if(getToken()){
				getInfo().then(res=>{
					
					this.$store.dispatch("Login",res)
				})
			}
			
		}
		
		
		 
		
	}
</script>

<style>
	
	  
	  .el-aside {
	    background-color: #D3DCE6;
	    color: #333;
	    text-align: center;
	    line-height: 200px;
	  }
	  
	  .el-main {
	    overflow: hidden;
	    color: #333;
	    text-align: center;
		background-color: #EFF4F9;
		padding: 0;
		height: auto;
		margin-bottom: 5vw;
	  }
	  
	  body > .el-container {
	    margin-bottom: 40px;
	  }
	  
	  .el-container:nth-child(5) .el-aside,
	  .el-container:nth-child(6) .el-aside {
	    line-height: 260px;
	  }
	  
	  .el-container:nth-child(7) .el-aside {
	    line-height: 320px;
	  }
	
</style>
